<template>
  <div v-if="isShow" data-testid="purchased_course_list" class="purchased-course">
    <div class="o-container o-container--responsive mb-8 relative">
      <div class="flex justify-between items-center p-16">
        <div class="flex items-center">
          <div class="h-8 w-8 rounded-full mr-8 flex justify-center items-center p-4 purchased-course__icon-color">
            <IcoEticket color="#3A5FD6" />
          </div>
          <BlTextAv weight="bold" variation="body-16" tag="h2" is-bolder>Kelas yang kamu beli</BlTextAv>
        </div>

        <BlButtonAv
          size="extra-small"
          class="p-0 min-w-[44px]"
          data-testid="btn-go-to-transaction"
          variation="naked"
          @click="goToTransactionPage"
        >
          <IcoChevronRightMinor color="#2B4AC7" />
        </BlButtonAv>
      </div>
      <div class="space-y-2 pb-16">
        <div class="ph-16 flex scroll-pl-4 space-x-2 overflow-x-auto snap-x pv-4">
          <div
            v-for="(purchasedCourse, index) in purchasedCourses"
            :key="index"
            data-testid="purchased_course_card"
            class="snap-start shrink-0 first:pl-6"
          >
            <PurchasedCourseCard :purchased-course="purchasedCourse" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {BlTextAv, BlButtonAv} from '@bukalapak/bazaar-mweb-latest';
import PurchasedCourseCard from '../PurchasedCourseCard/PurchasedCourseCard.vue';
import {IcoEticket} from '@bukalapak/bazaar-visual-next';
import prakerjaPurchasedCourses from 'src/shared/mixins/prakerja-purchased-course';
import {IcoChevronRightMinor} from '@bukalapak/bazaar-visual-next';

export default {
  name: 'PrakerjaPurchasedCourses',
  components: {
    BlTextAv,
    PurchasedCourseCard,
    IcoEticket,
    IcoChevronRightMinor,
    BlButtonAv,
  },
  mixins: [prakerjaPurchasedCourses],
  methods: {
    goToTransactionPage() {
      this.$router.push('/transaksi');
    },
  },
};
</script>

<style lang="scss" scoped>
.purchased-course {
  background-color: #ffffff;
  &__slide {
    padding: 8px !important;
  }
  &__icon-color {
    background-color: #ebf2fa;
  }
}
</style>
